import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import { scrollbarStyle } from '../../../styles/Scrollbar.styles'
import { standardInputStyle } from './StandardInput.styles'

// Interfaces for styled component props
interface InputWrapperProps {
  maxHeight?: number
}

interface OverflowIndicatorProps {
  show?: boolean
}

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  font-family: Inter, sans-serif;
  background-color: ${theme.colors.surface};
  width: 17rem;
  * {
    box-sizing: border-box;
  }
`

export const InputWrapper = styled.div<InputWrapperProps>`
  ${standardInputStyle({ highlightError: false })}
  display: flex;
  align-items: flex-start;
  min-height: 38px;
  padding-top: 0.6rem;
  background: transparent;
  width: 100%;
  padding-bottom: 0.3rem;
  background-color: ${theme.colors.surface};

  /* Dynamic max-height and overflow handling */
  max-height: ${(props) => (props.maxHeight ? `${props.maxHeight}px` : 'none')};
  overflow: ${(props) => (props.maxHeight ? 'hidden' : 'visible')};

  /* Base transition - applies to opening animation */
  transition:
    max-height 0.5s ease-in-out,
    padding 0.2s ease;

  /* Expand on hover or focus */
  &:hover,
  &:focus-within {
    max-height: ${(props) => (props.maxHeight ? '500px' : 'none')};
    overflow: hidden;
  }

  /* Special transition for collapsing only - applied when not hovering */
  &:not(:hover):not(:focus-within) {
    transition:
      max-height 0.5s ease 0.5s,
      padding 0.2s ease;
  }
`

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.4rem;
  gap: 6px;
  flex: 1;
`

export const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1 1 auto;
  width: 6rem;
  font-size: 14px;
  color: #344054;
  background: transparent;

  &::placeholder {
    color: #667085;
  }
`

export const SearchDropdown = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin-top: 2px;
  border: 1px solid ${theme.colors.backgroundDark};
  border-radius: 0.5rem;
  box-shadow: ${theme.shadows.light};
  max-height: 200px;
  overflow-y: auto;
  ${scrollbarStyle}
  z-index: 1000;
  background-color: ${theme.colors.surface};
`

export const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  color: #344054;
  font-size: 14px;
  padding-left: 2rem;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: #f9fafb;
  }
`

export const ItemIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  background: ${theme.colors.secondaryVeryVeryLight};
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 14px;
  color: ${theme.colors.standardText};
  gap: 4px;
`

export const TagWithIcon = styled(Tag)`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
`

export const TagCloseButton = styled.button`
  background: none;
  border: none;
  color: #667085;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  &:hover {
    color: #344054;
  }
`

export const OverflowIndicator = styled.div<OverflowIndicatorProps>`
  position: relative;
  bottom: 11px;
  left: 0;
  right: 0;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  height: 12px;
  pointer-events: none;

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${theme.colors.backgroundVeryDark};
    opacity: 0.6;
  }
`
